import React, { useState } from "react";
import Avatar from "../../../node_modules/@material-ui/core/Avatar";
import Button from "../../../node_modules/@material-ui/core/Button";
import CssBaseline from "../../../node_modules/@material-ui/core/CssBaseline";
import Typography from "../../../node_modules/@material-ui/core/Typography";
import TextField from "../../../node_modules/@material-ui/core/TextField";
import MenuItem from "../../../node_modules/@material-ui/core/MenuItem";
import { makeStyles } from "../../../node_modules/@material-ui/core/styles";
import Container from "../../../node_modules/@material-ui/core/Container";
// import SupportIcon from "@material-ui/icons/Support";

export default function Support() {
  const useStyles = makeStyles(theme => ({
    paper: {
      marginTop: theme.spacing(4),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%"
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main
    },
    form: {
      width: "100%",
      marginTop: theme.spacing(1)
    },
    submit: {
      margin: theme.spacing(3, 0, 2)
    },
    message: {
      marginTop: theme.spacing(3),
      textAlign: "center"
    }
  }));

  const classes = useStyles();
  const [submitted, setSubmitted] = useState(false);
  const [ticketId, setTicketId] = useState("");

  const submitTicket = event => {
    event.preventDefault();

    const ticketNo =
      "#TK-" + Math.floor(100000 + Math.random() * 900000);

    setTicketId(ticketNo);
    setSubmitted(true);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />

      <div className={classes.paper}>
        <p></p>
        <p></p>

        <Avatar className={classes.avatar}>
        
        </Avatar>

        <Typography component="h1" variant="h5">
          Support Center
        </Typography>

        {!submitted ? (
          <>
            <Typography
              component="p"
              variant="body1"
              className={classes.message}
            >
              How can we help?
            </Typography>

            <Typography
              component="p"
              variant="body2"
              className={classes.message}
            >
              Submit a support request and our team will get back to you.
            </Typography>

            <form
              className={classes.form}
              onSubmit={submitTicket}
              noValidate
            >
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="name"
                label="Your Name"
                name="name"
                autoComplete="name"
                autoFocus
              />

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                type="email"
                autoComplete="email"
              />

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                select
                id="category"
                label="Category"
                name="category"
                defaultValue=""
              >
                <MenuItem value="" disabled>
                  Select topic...
                </MenuItem>
                <MenuItem value="technical">
                  Technical Support
                </MenuItem>
                <MenuItem value="other">
                  General Inquiry
                </MenuItem>
              </TextField>

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                multiline
                rows={4}
                id="message"
                label="Message Details"
                name="message"
                placeholder="Describe your issue..."
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Submit Request
              </Button>
            </form>
          </>
        ) : (
          <>
            <Typography
              component="p"
              variant="h6"
              className={classes.message}
            >
              Request Submitted!
            </Typography>

            <Typography
              component="p"
              variant="body1"
              className={classes.message}
            >
              Your ticket ID is {ticketId}.
            </Typography>

            <Typography
              component="p"
              variant="body2"
              className={classes.message}
            >
              We'll reply via email shortly.
            </Typography>

            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={() => setSubmitted(false)}
            >
              Submit Another Request
            </Button>
          </>
        )}
      </div>
    </Container>
  );
}
